import { getPersistValue } from '/b2b/common/state/persist/Persist.selectors';

const emptyObject = {};

export const getPersistedVendorListState = state =>
    getPersistValue(state, 'vendors.vendorList', emptyObject);
